/* @ngInject */
function loginService($http, externalRedirect) {
    const URL = 'api/session/login';

    return {
        login: login
    };

    ////////////////

    /**
     * @param loginData
     * {
     *   agencyId: '123456789',
     *   userName: 'agency user name',
     *   password: 'agency password'
     * }
     * @returns a Promise
     */
    function login(loginData) {
        var request =  {
            agencyId: loginData.agencyId,
            userName: loginData.userName,
            password: loginData.password
        };

        return $http.post(URL, request)
            .then(loadComplete);
    }

    function loadComplete(response) {
        var data = response.data;

        externalRedirect.redirect(data.redirect);
    }

}

export default loginService;


/** WEBPACK FOOTER **
 ** ./src/main/assets/app/login/components/form/loginService.js
 **/